import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useT } from "@/i18n";

// Main hero CTA button. Swaps its label to "Start 7-Day Free Trial" when
// the admin has the trial enabled — otherwise falls back to the generic
// "Get Started" copy so we never advertise a benefit we don't deliver.
export default function TrialPrimaryCTA({ fallbackLabel }) {
  const { t } = useT();
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/billing/trial-config").then((r) => {
      if (alive) setCfg(r.data || null);
    }).catch(() => { /* fall back to generic label */ });
    return () => { alive = false; };
  }, []);

  const showTrialCopy = cfg?.enabled && cfg?.days;
  const label = showTrialCopy
    ? t("hero_cta_trial", { days: cfg.days })
    : fallbackLabel;

  return (
    <Link
      to="/auth?mode=register"
      data-testid="hero-cta-primary"
      className="btn-accent inline-flex items-center justify-center gap-2 text-sm font-bold px-7 py-4 rounded-md"
    >
      {label} <ArrowRight className="w-4 h-4" />
    </Link>
  );
}
